import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';

function HeadingWithLink({ heading, copy, linkText, slug }) {
  return (
    <article>
      <div className="flex flex-wrap items-center justify-center max-w-2xl mx-auto my-8 sm:my-12">
        <div className="flex flex-col items-center justify-center w-full p-8 mx-auto">
          <h2 className="text-lg font-medium uppercase md:text-2xl">
            {heading}
          </h2>
          <p className="py-1 text-xs uppercase md:text-sm">{copy}</p>
          <Link
            to={slug}
            className="px-20 mt-6 uppercase border button button-inverted border-dark-pink"
          >
            {linkText}
          </Link>
        </div>
      </div>
    </article>
  );
}

HeadingWithLink.propTypes = {
  copy: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export { HeadingWithLink };
